$(document).ready(function () {
  const closeAddCartFill = document.querySelector(".close-cart");
  const selectHalo = document.querySelector(".halo-modal");
  const selectOverlay = document.querySelector(".wrapper-overlay");
  const cartIcon = document.getElementById("iconCartToggle");

  cartIcon && cartIcon.addEventListener("click", () => {
    if (selectOverlay.classList.contains('not-show-modal')) {
      selectOverlay.classList.remove('not-show-modal');
    }
    if (selectOverlay.classList.contains('show-modal')) {
      selectOverlay.classList.remove('show-modal');
    }
  });
  closeAddCartFill && closeAddCartFill.addEventListener("click", () => {
    if (selectHalo.classList.contains('show-modal')) {
      selectHalo.classList.remove('show-modal');
    }
    if (selectOverlay.classList.contains('show-modal')) {
      selectOverlay.classList.remove('show-modal');
    }
    
    const selectOther = document.getElementById("dropdown-cart");
    selectOther.classList.remove("add-class-remove");
  });

  if ($(".product-cross-sell")) {
    $(".product-cross-sell").click(function (element) {
      const data = {
        id: $(this).data("variant-id"),
        add: "Ajouter au panier",
        form_type: "product",
        "option-0": "10",
        utf8: "✓",
      };
      const handler = $(this).data("collections-related");
      window.ella.doAjaxAddToCart(data, handler);
    });
  }

  const textButtonCart = document.getElementById('button-comander');
  const selectLanguage = document.querySelectorAll('.text-static-lang');
  const textLanguagesT = document.getElementById('language-picker-menu');
  const textShipping= document.getElementById('text-shipping');
  const priceCalculated= document.getElementById('price-calculated');
  const priceCalculatedQ= $('#dropdown-cart'); 
  
  if(textLanguagesT){
    if(textLanguagesT.innerHTML == "Languages" || textLanguagesT.innerHTML == "EN"){
      textButtonCart.innerHTML = "ORDER"
      textShipping.innerHTML = "Total shipping"
      if(priceCalculated.textContent.includes("Calc")){
        priceCalculatedQ.find(".summary .priceProd").html("Calculate next step") 
      }else{
        priceCalculatedQ.find(".summary .priceProd").html("Free") 
      } 

    }else{
      textButtonCart.innerHTML = "COMMANDER"
      textShipping.innerHTML = "Frais d'envoi"
      if(priceCalculated.textContent.includes("Calc")){
        priceCalculatedQ.find(".summary .priceProd").html("Calculé à l'étape suivante")
      }else{
        priceCalculatedQ.find(".summary .priceProd").html("Gratuit")
      }
      
    }
  }
  for (let i = 0; i < selectLanguage.length; i++) {
    selectLanguage[i].addEventListener("click", (e) => {
     const lang = e.target.dataset.desktoptext;
     
     if(lang == "EN"){
      textButtonCart.innerHTML = "ORDER"
      textShipping.innerHTML = "Total shipping"   
      if(priceCalculated.textContent.includes("Calc")){
        priceCalculatedQ.find(".summary .priceProd").html("Calculate next step")
      }else{
        priceCalculatedQ.find(".summary .priceProd").html("Free")
      }

     }else{
      textButtonCart.innerHTML = "COMMANDER"
      textShipping.innerHTML = "Frais d'envoi"
      if(priceCalculated.textContent.includes("Calc")){
        priceCalculatedQ.find(".summary .priceProd").html("Calculé à l'étape suivante");
      }else{
        priceCalculatedQ.find(".summary .priceProd").html("Gratuit")
      }
     }
    })
  }
});
